import axios from 'axios';
import React, { Component, useState } from 'react'
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import ReactPaginate from 'react-paginate';
import "./hojasestilogestiontitulacion.css";

import * as XLSX from "xlsx-js-style";

const claveApi = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const carrerasUrl = ApiUrl + "listarcarreras" + claveApi;
const baseUrlPeriodos = ApiUrl + "listperiodostodos" + claveApi;
const urlListaEstudTipoTitulacion = ApiUrl + "reportestudtipotitula" + claveApi;
const urlListarTiposTitulacion = ApiUrl + "listartipotitul" + claveApi;

let listaauxiliar = [];
const itemsPerPage = 10;

export default class ReportEstudTipoTitul extends Component {

    constructor(props) {
        super(props)
        this.state = {
            carrera: [],
            estud: [],
            EstudianteBackup: [],
            textBuscar: "",
            periodos: [],
            estado: "",
            idPeriodo: "1",
            idCarrera: "1",
            listtipotitulacion: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }


    componentDidMount() {
        axios
            .get(baseUrlPeriodos, {})
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ periodos: listaperiodos });
                }
            })

        axios.get(carrerasUrl)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })
    }


    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;   //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1
        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }

    handleChangeTipoTitulacionCarrera = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios
            .post(urlListarTiposTitulacion, {
                idCarreraTipoT: this.state.idCarrera
            })
            .then(response => {

                const listatipotitul = response.data.data;
                const cant = listatipotitul.length;
                if (cant != 0) {
                    this.setState({ listtipotitulacion: listatipotitul });
                }
                else {
                    this.setState({ error: "No existe tipos de titulación " });
                    swal({
                        text: "¡No existe tipos de titulación!",
                        icon: "info",
                        button: "Aceptar",
                    });

                }
            })
    }

    handleChangeEstudTipoTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios
            .post(urlListaEstudTipoTitulacion, {
                idCarrera: this.state.idCarrera,
                idPeriodo: this.state.idPeriodo,
                idTipoTitulacion: this.state.idTipoTitulacion
            })
            .then(response => {
                if (response.data.success == true) {
                    listaauxiliar = response.data.data;
                    const estud = response.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const EstudianteBackup = estud;
                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });

                    //PAGINACION
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  DE LA PAGINACION
                    this.setState({ estado: "" });

                } else {
                    const estudiantes = [];
                    this.setState({ estudiantes });
                    this.setState({ estado: "No existe datos para mostrar" });
                    swal({
                        text: "No existe datos para mostrar",
                        icon: "info",
                        button: "Aceptar",
                    });

                }
            })
            .catch(error => {
                const estudiantes = [];
                this.setState({ estudiantes });
                this.setState({ estado: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }

    //Exportar a excel
    exportToExcelEstudTipoT = () => {
        const {
            estud = [],
            idPeriodo,
            idCarrera,
            idTipoTitulacion,
            periodos = [],
            carrera = [],
            listtipotitulacion = [],
        } = this.state;

        // Nombres legibles
        const periodoSel = periodos.find(p => String(p.id_periodo_academico) === String(idPeriodo));
        const carreraSel = carrera.find(c => String(c.id_carrera) === String(idCarrera));
        const tipoSel = listtipotitulacion.find(t => String(t.id_tipo_titulacion) === String(idTipoTitulacion));

        const nomPeriodo = periodoSel?.descripcion_periodo_academico || '-';
        const nomCarrera = carreraSel?.descripcion_carrera || '-';
        const nomTipo = tipoSel?.nom_tipo_titulacion || '-';

        // Armamos matriz en dos columnas (col A = etiqueta, col B = valor)
        const aoa = [
            [{ v: "Reporte de estudiantes de un tipo de titulación", s: { font: { bold: true, sz: 12 } } }],
            [
                { v: "Período:", s: { font: { bold: true } } },
                { v: nomPeriodo, s: { font: { bold: false } } }
            ],
            [
                { v: "Carrera:", s: { font: { bold: true } } },
                { v: nomCarrera, s: { font: { bold: false } } }
            ],
            [
                { v: "Tipo de titulación:", s: { font: { bold: true } } },
                { v: nomTipo, s: { font: { bold: false } } }
            ],
            [],
            [
                { v: "Cédula", s: { font: { bold: true } } },
                { v: "Primer Apellido", s: { font: { bold: true } } },
                { v: "Segundo Apellido", s: { font: { bold: true } } },
                { v: "Primer Nombre", s: { font: { bold: true } } },
                { v: "Segundo Nombre", s: { font: { bold: true } } },
                { v: "Tutor", s: { font: { bold: true } } },
                { v: "Calificación", s: { font: { bold: true } } }
            ]
        ];

        estud.forEach(r => {
            const tutor = `${r.nombres_administrativo || ''} ${r.apellidos_administrativo || ''}`.trim();
            const nota = (r.nota_final !== null && r.nota_final !== undefined)
                ? Number(r.nota_final).toFixed(2)
                : '0.00';

            aoa.push([
                r.numero_identificacion_estudiante || '',
                r.primer_apellido_estudiante || '',
                r.segundo_apellido_estudiante || '',
                r.primer_nombre_estudiante || '',
                r.segundo_nombre_estudiante || '',
                tutor,
                nota
            ]);
        });

        const ws = XLSX.utils.aoa_to_sheet(aoa);

        // Rango total
        const range = XLSX.utils.decode_range(ws['!ref']);

        // === Estilo para los primeros 4 renglones (título + meta) ===
        for (let R = 0; R <= 3; ++R) {
            const cell = ws[XLSX.utils.encode_cell({ r: R, c: 0 })];
            if (cell) {
                cell.s = { font: { bold: true } };
            }
        }

        // === Estilo solo para cabecera de la tabla (fila 5 = índice 5) ===
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cell = ws[XLSX.utils.encode_cell({ r: 5, c: C })];
            if (cell) {
                cell.s = { font: { bold: true } };
                cell.s = {
                    font: { name: "Calibri", sz: 11, bold: true, color: { rgb: "000000" } },
                    // fill: { fgColor: { rgb: "2d465f" } },  // azul de encabezado
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } }
                    },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }

        }


        // === Bordes para toda la tabla de datos ===
        for (let R = 6; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
                if (cell) {
                    cell.s = { ...cell.s }
                    cell.s = {
                        font: { name: "Calibri", sz: 11, bold: false, color: { rgb: "000000" } },
                        // fill: { fgColor: { rgb: "4F81BD" } },  // azul de encabezado
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } }
                        },
                        alignment: { horizontal: "center", vertical: "center" }
                    };

                }
            }
        }


        // Ajuste de columnas
        ws['!cols'] = [
            { wch: 14 },
            { wch: 16 },
            { wch: 18 },
            { wch: 16 },
            { wch: 18 },
            { wch: 38 },
            { wch: 12 },
        ];

        // Crear libro y descargar
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Reporte');


        const filename = `reporte-estudiantes_${nomCarrera}_${nomTipo}.xlsx`;
        XLSX.writeFile(wb, filename);
    };



    render() {
        return (

            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{ }</li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fas fa-graduation-cap icono-animado"></i>
                        <b className="mb-0 fw-semibold"> Reporte de estudiantes de un tipo de titulación</b>
                    </div>

                    <div className="card-body">
                        <div class="row">
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 " >
                                <div className="mb-3">
                                    <label className="form-label"><b> <i className="fa-magnifying-glass"></i> Buscar:</b></label>
                                    <input type="text" class="form-control col-md-12" value={this.state.text} placeholder="Buscar..." onChange={(text) => this.filter(text)} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 " >
                                <div className="mb-3">
                                    <label className="form-label"><b> <i className="fa fa-calendar"></i> Período</b></label>
                                    <select className="form-select" name="idPeriodo" value={this.state.value} onChange={this.handleChange} aria-label="Default select example">
                                        <option value="undefined" selected="true" disabled>Seleccione el periódo</option>
                                        {this.state.periodos.map(periodo => <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico} > {periodo.descripcion_periodo_academico}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 " >
                                <div className="mb-3">

                                    <label className="form-label"><b>Carrera</b></label>
                                    <select className="form-select" id="idCarrera" name="idCarrera" value={this.state.value} onChange={this.handleChangeTipoTitulacionCarrera} aria-label="Default select example">
                                        <option value="undefined" selected="true" disabled>Seleccione una carrera</option>
                                        {this.state.carrera.map(person => <option key={person.id_carrera} value={person.id_carrera} > {person.descripcion_carrera}</option>)}
                                    </select>

                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 " >
                                <div className="mb-3">
                                    <label className="form-label"><b>Tipos titulación</b></label>
                                    <select className="form-select" name="idTipoTitulacion" value={this.state.value} onChange={this.handleChangeEstudTipoTitulacion} aria-label="Default select example">
                                        <option value="undefined" selected="true" disabled>Seleccione un tipo titulación</option>
                                        {this.state.listtipotitulacion.map(person => <option key={person.id_tipo_titulacion} value={person.id_tipo_titulacion} > {person.nom_tipo_titulacion}</option>)}
                                    </select>
                                </div>
                            </div>

                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3 ">
                            </div>
                        </div>

                        <div className="row ">

                            <div className="p-3 rounded-3 mt-3">
                                <h6 className="fw-bold text-center mb-3 text-azul">Reporte de estudiantes</h6>

                                <div class="table-responsive">
                                    <table className="table table-hover table-sm-custom" >
                                        <thead className="table-light">
                                            <tr className="text-start text-azul" >
                                                <th scope="col">Cédula</th>
                                                <th scope="col">Primer Apellido</th>
                                                <th scope="col">Segundo Apellido</th>
                                                <th scope="col">Primer Nombre</th>
                                                <th scope="col">Segundo Nombre</th>
                                                <th scope="col">Tutor</th>
                                                <th scope="col">Calificación</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.currentItems &&
                                                this.state.currentItems.map((consola) => (
                                                    <tr
                                                        className="text-start text-azul list-afiliados"
                                                        key={consola.id_estudiante} >
                                                        <td>{consola.numero_identificacion_estudiante}</td>
                                                        <td>{consola.primer_apellido_estudiante}</td>
                                                        <td>{consola.segundo_apellido_estudiante}</td>
                                                        <td>{consola.primer_nombre_estudiante}</td>
                                                        <td>{consola.segundo_nombre_estudiante}</td>
                                                        <td>
                                                            {`${consola.nombres_administrativo || ""} ${consola.apellidos_administrativo || ""}`.trim() || "—"}
                                                        </td>
                                                        <td>
                                                            {consola.nota_final !== null && consola.nota_final !== undefined
                                                                ? Number(consola.nota_final).toFixed(2)
                                                                : "0.00"}
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex justify-content-center mt-4 ">
                                    <ReactPaginate
                                        previousLabel="<"
                                        nextLabel=">"
                                        pageCount={this.state.pageCount}
                                        onPageChange={this.handlePageClick}
                                        containerClassName="pagination pagination-sm-custom"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>
                                <div className="d-flex justify-content-center mt-4 ">
                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm fw-semibold"
                                        onClick={this.exportToExcelEstudTipoT}
                                    >
                                        <i className="fas fa-file-excel me-2"></i>
                                        Exporta a Excel
                                    </button>

                                </div>
                            </div>


                        </div>




                        {/* fIN DE ESCONDIDOS */}
                        <br />
                        <div className="alert alert-info text-azul" role="alert" hidden={this.state.hidden}>
                            {this.state.estado}</div>

                    </div>
                </div>
            </div>
        )
    }
}

